import React from 'react';
import ProductCard from './ProductCard';
import { useStore } from '../../context/StoreContext';

export default function ProductGrid() {
  const { getFilteredProducts, visible, setVisible } = useStore();
  const filtered = getFilteredProducts();
  const displayedProducts = filtered.slice(0, visible);
  const hasMore = visible < filtered.length;

  return (
    <>
      <div id="productGrid" className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 lg:gap-6">
        {displayedProducts.map(product => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
      {hasMore && (
        <div className="mt-12 flex justify-center">
          <button 
            onClick={() => setVisible(prev => prev + 8)}
            className="px-6 h-12 rounded-2xl border border-slate-300 font-semibold text-sm hover:bg-slate-50"
          >
            Load More
          </button>
        </div>
      )}
    </>
  );
}